module.exports = __webpack_public_path__ + "static/media/invoice-and-bills.2ea126c0.png";